
import { defineComponent, ref } from 'vue';
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import { useRoute } from 'vue-router';
import { useAgencys } from '@/modules';

export default defineComponent({
  components: { Button, Dialog },
  setup() {
    const agencyModule = useAgencys();
    const route = useRoute();
    const displaySuccessCreateAgency = ref(false);
    const brandRef = ref();
    const influencerRef = ref();

    const changeStyle = (ref: 'brandRef' | 'influencerRef') => {
      if (ref === 'influencerRef') {
        brandRef.value.classList.add('small');
        brandRef.value.classList.add('hide-title');
      }
      if (ref === 'brandRef') {
        influencerRef.value.classList.add('small');
        influencerRef.value.classList.add('hide-title');
      }
    };
    const removeStyle = (ref: 'brandRef' | 'influencerRef') => {
      if (ref === 'influencerRef') {
        brandRef.value.classList.remove('small');
        brandRef.value.classList.remove('hide-title');
      }
      if (ref === 'brandRef') {
        influencerRef.value.classList.remove('small');
        influencerRef.value.classList.remove('hide-title');
      }
    };

    if (route.query?.invite) {
      localStorage.setItem('inviteCampaign', route.query.invite?.toString());
    }

    if (route?.query?.confirmCode && route?.query?.userId) {
      agencyModule.manager.confirmCreateAgency(
          route.query.confirmCode as string,
          route?.query?.userId as string,
      ).then((success: boolean) => {
        if (success) {
          displaySuccessCreateAgency.value = true;
        }
      });
    }

    // const convertStyle = () => {
    //   const height = window.innerHeight;
    //   const box = document.getElementById("section-lending");
    //   if (box) {
    //     box.style.height = `${height}px`;
    //   }
    // };
    // window.addEventListener("resize", convertStyle);
    // window.addEventListener("DOMContentLoaded", convertStyle);

    return {
      brandRef,
      influencerRef,
      displaySuccessCreateAgency,
      changeStyle,
      removeStyle,
    };
  },
});
